import { Component, OnInit, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable }  from 'rxjs/Observable';
import { SpellCheckService } from './spell-check.service';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/observable/fromEvent';

@Component({
  selector: 'ng-spell-check',
  template: `<div class="ng-spell-check">
  <textarea 
    class="b-text-area"
    [formControl]="textAreaCtrl"
    ([ngModel])="textData"
    [value] = "textData | sanitizeHTML "
  >
  
  </textarea>
  <div class="b-back-drop">
      <div class="b-text-correction" 
      >
        <span class="s-word-container" *ngFor="let keyword of corrections">
          <mark *ngIf="needToCorrect(keyword) >= 0" 
            [innerHTML]="keyword" 
            (blur)="hideReplacements()"
            (click)="showReplacements($event, keyword)">
          </mark>
          <span class="correct-word" *ngIf="needToCorrect(keyword) < 0" [innerHTML]="keyword"></span>
          <div *ngIf="showPopover && selectedWrongWord == keyword" class="b-correct-word-list">
              <ul>
                <li
                *ngFor="let correctWord of correctWordList" 
                [innerHTML]="correctWord.value"
                (click)="replaceWord(correctWord.value)">
                </li>
              </ul>
            </div>
        </span>
        
      </div>
    </div>
</div>`,
  styles: [`.ng-spell-check{position:relative;font-family:"Arial, Helvetica, sans-serif";font-size:1rem}.ng-spell-check textarea{font-family:"Arial, Helvetica, sans-serif";font-size:1rem;width:100%}.ng-spell-check .b-back-drop{position:absolute;width:100%;top:0;z-index:1;border:1px solid transparent;overflow:visible;transition:-webkit-transform 1s;-webkit-transition:-webkit-transform 1s;transition:transform 1s;transition:transform 1s,-webkit-transform 1s}.ng-spell-check .b-text-correction{padding:2px}.ng-spell-check .b-text-correction .s-word-container{position:relative}.ng-spell-check .b-text-correction .s-word-container mark{cursor:pointer}.ng-spell-check .b-text-correction .s-word-container span.correct-word{color:transparent}.ng-spell-check .b-text-correction .s-word-container .b-correct-word-list{position:absolute;top:20px;left:0;cursor:pointer;background:#fff;border:1px solid #ccc;font-size:.8rem;min-width:100px}.ng-spell-check .b-text-correction .s-word-container .b-correct-word-list ul{margin:0;padding:0;list-style:none}.ng-spell-check .b-text-correction .s-word-container .b-correct-word-list ul li{padding:5px 2px}.ng-spell-check .b-text-correction .s-word-container .b-correct-word-list ul li:hover{background:#eee}`]
})

export class SpellCheckComponent implements OnInit {
  @HostListener('document:click', ['$event']) clickedOutside($event){
    // here you can hide your menu
    this.showPopover = false;
  }

  public  textData = ""
          showPopover = false
          selectedWrongWord
          correctWordList =[]
          corrections;
  private textAreaCtrlSub;

  // first api for spell check
  /**
   * To do
   * Replace this variable with another variable that can be defined as an
   * attribute
   */

  
  textAreaCtrl = new FormControl();
  private subscribers = <any>[];
  public wordsToBeCorrected = new Array();

  constructor(
    private spellCheckService: SpellCheckService
  ) {

    let textAreaClearSub = this.textAreaCtrl.valueChanges
    .subscribe((value)=>{
      // clear correction data when new inputs are detected
      this.corrections = [];
    })

    let textAreaCtrlSub = this.textAreaCtrl.valueChanges
    .debounceTime(3000)
    .subscribe((value)=>{
      // spell check entered value
      this.checkText(value);
      this.textData = value;
    })

    this.subscribers.push(this.textAreaCtrlSub);
   }
  
  ngOnInit() {
  }

  checkText(input){
    let spellCheckSub = this.spellCheckService.checkWithLanguageTool(input).subscribe((res)=>{
      if(res.matches){
        // place each possible replacement into key value pair
        res.matches.forEach((word)=>{
          let wrongWord = word.context.text.substring(word.context.offset, word.context.offset + word.context.length);
          this.wordsToBeCorrected[wrongWord] = word.replacements;
        })

        // use regex to replace all wrong words in the list to have a highlight indicator
        let markedText = input.replace(new RegExp(Object.keys(this.wordsToBeCorrected).join("|"), "gi"), word =>{
          return "<mark>" + word +"<mark>";
        })

        this.corrections = markedText.split("<mark>");
      }
    })
    this.subscribers.push(spellCheckSub);
  }
  
  showReplacements($event, word){
    this.showPopover = true;
    this.selectedWrongWord = word;
    this.correctWordList = this.wordsToBeCorrected[word];
    $event.preventDefault();
    $event.stopPropagation(); 
  }
  hideReplacements(){
    this.showPopover = false;
  }
  needToCorrect(word){
    return Object.keys(this.wordsToBeCorrected).indexOf(word);
  }

  replaceWord(word){
    this.textData = this.textData.replace(this.selectedWrongWord, word);    
    const indexOfWord = this.corrections.indexOf(this.selectedWrongWord);
    this.corrections = [];
    this.checkText(this.textData);
  }

  ngOnDestroy(){
    this.subscribers.each((subscriber)=>{
      subscriber.unsubscribe();
    })
    this.subscribers = [];
  }
  
}
